import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldInputProps {
    field: FormFieldDto;
}

export function FormFieldInput({ field }: FormFieldInputProps) {
    const pattern = field.validation?.find((v) => v.type === 'pattern')?.value;
    const title = field.validation?.find((v) => v.type === 'pattern')?.message;
    const minLength = field.validation?.find((v) => v.type === 'minLength')?.value;
    const maxLength = field.validation?.find((v) => v.type === 'maxLength')?.value;

    const commonProps = {
        name: field.name,
        required: field.required,
        placeholder: field.options?.placeholder,
        defaultValue: field.options?.defaultValue,
    };

    switch (field.type) {
        case 'email':
        case 'text':
        case 'tel':
        case 'url':
            return (
                <Input
                    {...commonProps}
                    type={field.type}
                    className="form-input"
                    pattern={pattern}
                    title={title}
                    minLength={minLength ? parseInt(minLength) : undefined}
                    maxLength={maxLength ? parseInt(maxLength) : undefined}
                />
            );
        default:
            return null;
    }
}
